import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    notification: {
        background: theme?.app?.applicationColors.enumColors.grey ||
            '#202020',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    },
    notificationSuccess: {
        background: theme?.app?.applicationColors.success ||
            '#A5D673',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    },
    notificationError: {
        background: theme?.app?.applicationColors.failure ||
            '#FA5252',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    }
}));